(() => {
 const attach = () => document.querySelectorAll('.header__inline-menu details').forEach(details => {
  if (details.dataset.elementreHover) return;
  details.dataset.elementreHover = 'true';
  let timer;
  const enabled = () => window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  const state = open => { details.open = open; details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open)); };
  details.addEventListener('pointerenter', () => { if (!enabled()) return; clearTimeout(timer); state(true); });
  details.addEventListener('pointerleave', () => { if (!enabled()) return; timer = setTimeout(() => { if (!details.contains(document.activeElement)) state(false); }, 180); });
  details.addEventListener('focusout', () => { setTimeout(() => { if (!details.contains(document.activeElement) && !details.matches(':hover')) state(false); },0); });
  details.addEventListener('keydown', event => { if (event.key === 'Escape') { state(false); details.querySelector(':scope > summary')?.focus(); } });
 });
 document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', attach) : attach();
 document.addEventListener('shopify:section:load', attach);
})();
